/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPlansResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type PlansResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/subscriptions/plans
 */
export interface PlansRequestBuilder extends BaseRequestBuilder<PlansRequestBuilder> {
    /**
     * Gets the active billing catalog — the sellable products and their recurring prices, with any quantity limits — for rendering the subscribe page, plus the trial length in days (trialPeriodDays) that checkout applies, so the page can state when the first charge lands.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PlansResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<PlansRequestBuilderGetQueryParameters> | undefined) : Promise<PlansResponse | undefined>;
    /**
     * Gets the active billing catalog — the sellable products and their recurring prices, with any quantity limits — for rendering the subscribe page, plus the trial length in days (trialPeriodDays) that checkout applies, so the page can state when the first charge lands.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<PlansRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Gets the active billing catalog — the sellable products and their recurring prices, with any quantity limits — for rendering the subscribe page, plus the trial length in days (trialPeriodDays) that checkout applies, so the page can state when the first charge lands.
 */
export interface PlansRequestBuilderGetQueryParameters {
    /**
     * The catalog family to read from. Optional — blank meansDefaultItemFamilyId. Callers that omit it can still send it through as an emptystring: a generated client expanding ?itemFamilyId={itemFamilyId} with no value produces?itemFamilyId=, so the default has to survive an empty string and not just an absent one.
     */
    itemFamilyId?: string;
}
/**
 * Uri template for the request builder.
 */
export const PlansRequestBuilderUriTemplate = "{+baseurl}/api/organizations/subscriptions/plans?itemFamilyId={itemFamilyId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const PlansRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: PlansRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPlansResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
